export default [
  {
    header: 'FAQs.mainVerticalMenu.FAQs',
    resource: ['FAQs', 'FAQCategory'],
    action: 'read',
  },
  {
    title: 'FAQs.mainVerticalMenu.FAQCategory',
    icon: 'ListIcon',
    resource: 'faqCategory',
    action: 'read',
    children: [
      {
        title: 'FAQs.mainVerticalMenu.FAQCategoryList',
        route: 'pages-FAQs-categories-list',
        resource: 'faqCategory',
        action: 'read',
      },
      {
        title: 'FAQs.mainVerticalMenu.FAQCategoryAdd',
        route: 'pages-FAQs-categories-add',
        resource: 'faqCategory',
        action: 'create',
      },
    ],
  },
  {
    title: 'FAQs.mainVerticalMenu.FAQs',
    icon: 'HelpCircleIcon',
    resource: 'faq',
    action: 'read',
    children: [
      {
        title: 'FAQs.mainVerticalMenu.FAQsList',
        route: 'pages-FAQs-list',
        resource: 'faq',
        action: 'read',
      },
      {
        title: 'FAQs.mainVerticalMenu.FAQAdd',
        route: 'pages-FAQs-add',
        resource: 'faq',
        action: 'create',
      },
    ],
  },
]
